
import { Alert, AlertColor, AlertPropsColorOverrides, Snackbar } from '@mui/material';
import React, { memo } from 'react';
import { OverridableStringUnion } from '@mui/types';

interface INotification {
  open: boolean;
  delayTime?: number | null;
  msg?: string;
  type?: OverridableStringUnion<AlertColor, AlertPropsColorOverrides>;
  close: () => void;
}

export const NotificationPopup = memo(({ open, delayTime, msg, type, close }: INotification) => {
  React.useEffect(() => {
    if (!open) {
      return;
    }
    const timeID = setTimeout(() => {
      close();
    }, delayTime ?? 2000);
    return () => clearTimeout(timeID);
  }, [open]);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
    >
      <Alert onClose={close} severity={type} variant='filled' sx={{ width: '100%' }}>
        {msg}
      </Alert>
    </Snackbar>
  );
});
